export default __webpack_public_path__ + "assets/basemap-toggle-64.svg";